import { useTranslation } from "react-i18next";
import { getImpersonation, clearImpersonation } from "../pages/Impersonate";

export default function ImpersonationBanner() {
  const { t } = useTranslation("common");
  const { active, email } = getImpersonation();

  if (!active) return null;

  function handleExit() {
    clearImpersonation();
    window.close();
    // Fallback: if the browser blocks window.close(), redirect to a blank page
    window.location.href = "about:blank";
  }

  return (
    <div className="sticky top-0 z-[60] flex items-center justify-center gap-3 bg-amber-400 px-4 py-2 text-sm font-medium text-amber-950">
      <span>
        {t("impersonation.viewing", { email })}
      </span>
      <span className="text-amber-700">·</span>
      <button
        type="button"
        onClick={handleExit}
        className="rounded bg-amber-600 px-2.5 py-0.5 text-xs font-semibold text-white hover:bg-amber-700 transition-colors"
      >
        {t("impersonation.backToAdmin")}
      </button>
    </div>
  );
}
